define('../app/fukit/collection/resource.query.collection',['require','exports','module','underscore','./base.collection','backbone','datakit/datakit','appkit/appkit','backbone.radio','evicommon/spf/model/sort','../helpers/model.util'],function(require, exports, module) {
  //prettier-ignore
  var _              = require('underscore'),
      BaseCollection = require('./base.collection'),
      Backbone       = require('backbone'),
      DataKit        = require('datakit/datakit'),
      AppKit         = require('appkit/appkit'),
      Radio          = require('backbone.radio'),
      SortModel      = require('evicommon/spf/model/sort'),
      ModelUtil      = require('../helpers/model.util');

  function resolveObjectWithStateValues(obj) {
    return AppKit.util.KeyPrefixer.resolve(obj, {
      '@state.': function(stateKey) {
        var state = Radio.request('AppKit.controllerService', 'state');
        if (state) {
          return state.get(stateKey);
        }
      },
    });
  }

  var Resource = Mn.Object.extend({
    initialize: function(options, execution) {
      Mn.Object.prototype.initialize.apply(this, arguments);

      var Collection = this.options.resourceClass;

      this.collection =
        this.options.collection ||
        new Collection([], {
          paginateAutoFetch: false,
          sortAutoFetch: false,
        });

      if (this.options.urlParams) {
        var urlParams = resolveObjectWithStateValues(this.options.urlParams);
        this.collection.urlParams(urlParams);
      }
      this.execution = execution;
      this.name = this.options.name || this.options.as;
    },

    initializeSort: function() {
      if (this.isSortResource()) {
        var sortModel = this.collection.sort;
        sortModel.set(SortModel.SORT_FIELD, this.getSortField());
        sortModel.set(SortModel.SORT_DIRECTION, this.getSortDirection());
      }
    },

    initializeFilters: function() {
      var filters = this.execution.query.filters;
      filters.each(function(filter) {
        if (this.isFilterForMe(filter)) {
          var parsedFilter = this.getParsedFilter(filter);
          this.collection.filters.add(parsedFilter);
        }
      }, this);
    },

    findOwnedModelFromList: function(models) {
      return _.find(
        models,
        function(model) {
          return !!this.collection.get(model);
        },
        this
      );
    },

    findAllLinkedByModel: function(model) {
      return [];
    },

    findAllLinkedByExternalModel: function(model, joinRecursionMemory) {
      var internalModel = this.findByExternalJoinModel(model);
      if (!internalModel) {
        return [];
      }
      return this.findAllLinkedByModel(internalModel, joinRecursionMemory || {});
    },

    findByExternalJoinModel: function() {
      return null;
    },

    isSortResource: function() {
      //prettier-ignore
      var sortModel = this.execution.query.sort,
          resourceName = this.execution.findResourceNameFromField(sortModel.get(SortModel.SORT_FIELD)),
          sortFieldParsed = this.execution.parseResourcePath(sortModel.get(SortModel.SORT_FIELD));

      if (!sortFieldParsed) {
        return false;
      }

      return resourceName == this.name && sortFieldParsed.field;
    },

    isFilterForMe: function(filter) {
      //prettier-ignore
      var field        = filter.get('field') || new Backbone.Model(),
          resourceName = this.execution.findResourceNameFromField(field.get('name'));

      return resourceName == this.name;
    },

    getParsedFilter: function(filter) {
      //prettier-ignore
      var field = filter.get('field') || new Backbone.Model(),
          nameFieldParsed = this.execution.parseResourcePath(field.get('name')),
          clonedFilter = filter.clone(),
          clonedField = field.clone();
      clonedField.set('name', nameFieldParsed.field);
      clonedFilter.set({
        field: clonedField,
      });
      return clonedFilter;
    },

    getSortField: function() {
      //prettier-ignore
      var sortModel = this.execution.query.sort,
          sortFieldParsed = this.execution.parseResourcePath(sortModel.get(SortModel.SORT_FIELD));
      return sortFieldParsed ? sortFieldParsed.field : '';
    },

    getSortDirection: function() {
      var sortModel = this.execution.query.sort;
      return sortModel.get(SortModel.SORT_DIRECTION) || SortModel.ASCENDING;
    },

    getJoinedResource: function() {
      return null;
    },

    getJoinedModel: function(model) {
      return model;
    },

    doesOwnModel: function(model) {
      return this.collection.get(model) != null;
    },
  });

  var QueryResource = Resource.extend({
    initialize: function() {
      Resource.prototype.initialize.apply(this, arguments);

      var filterArray = _.map(this.options.where, function(filter) {
        return resolveObjectWithStateValues(filter);
      });
      this.collection.filters.add(filterArray);
    },

    findAllLinkedByModel: function(model, joinRecursionMemory) {
      joinRecursionMemory || (joinRecursionMemory = {});
      if (joinRecursionMemory[model.cid]) {
        return [];
      }
      joinRecursionMemory[model.cid] = true;

      var linkedModels = _.reduce(
        this.execution.getResourcesByType(JoinResource),
        function(memo, joinedResource) {
          return memo.concat(joinedResource.findAllLinkedByExternalModel(model, joinRecursionMemory));
        },
        [],
        this
      );

      return [model].concat(linkedModels);
    },

    findByExternalJoinModel: function(model) {
      var joinResource = this.execution.findResourceForModel(model);
      if (!joinResource || joinResource.getJoinedResource() !== this) {
        return null;
      }
      var joinFilter = joinResource.getJoinFilter();
      var findWhere = {};
      findWhere[joinFilter.value.field] = model.get(joinFilter.field);
      return this.collection.findWhere(findWhere);
    },
  });

  var JoinResource = Resource.extend({
    findAllLinkedByModel: function(model, joinRecursionMemory) {
      var outputArray = [];
      joinRecursionMemory || (joinRecursionMemory = {});
      if (joinRecursionMemory[model.cid]) {
        return outputArray;
      }
      joinRecursionMemory[model.cid] = true;
      outputArray.push(model);
      var joinedResource = this.getJoinedResource();
      if (!joinedResource) {
        return outputArray;
      }
      return outputArray.concat(joinedResource.findAllLinkedByExternalModel(model, joinRecursionMemory));
    },

    findByExternalJoinModel: function(model) {
      var joinFilter = this.getJoinFilter();
      model = this.getJoinedModel(model);
      if (!model) {
        return;
      }
      var findWhere = {};
      findWhere[joinFilter.field] = model.get(joinFilter.value.field);
      return this.collection.findWhere(findWhere);
    },

    getJoinedResource: function() {
      var joinFilter = this.getJoinFilter();
      return this.execution.getResource(joinFilter.value.resourceName);
    },

    getJoinedModel: function(model) {
      if (!model) {
        return model;
      }

      this.joinedModelCache || (this.joinedModelCache = {});

      if (this.joinedModelCache[model.cid]) {
        return this.joinedModelCache[model.cid];
      }

      //prettier-ignore
      var originalModel  = model,
          targetResource = this.getJoinedResource();

      if (targetResource && !targetResource.doesOwnModel(model)) {
        model = targetResource.findByExternalJoinModel(model);
      }

      this.joinedModelCache[originalModel.cid] = model;

      return model;
    },

    getJoinFilter: function() {
      //prettier-ignore
      var fieldPath = _.keys(this.options.on)[0],
          valuePath = this.options.on[fieldPath],
          parsedField = this.execution.parseResourcePath(fieldPath),
          parsedValue = this.execution.parseResourcePath(valuePath);

      if (this.name == parsedValue.resourceName) {
        var saved = parsedValue;
        parsedValue = parsedField;
        parsedField = saved;
      }

      if (this.name != parsedField.resourceName) {
        parsedField.resourceName = this.name;
      }

      return {
        field: parsedField.field,
        value: parsedValue || {},
      };
    },

    buildFilterFromJoin: function() {
      //prettier-ignore
      var filters = this.collection.filters,
          joinFilter = this.getJoinFilter(),
          joinedResource = this.getJoinedResource();
      if (!joinedResource) {
        return;
      }
      joinedResource.collection.each(function(model) {
        var value = model.get(joinFilter.value.field);
        if (value != null && String(value).length > 0) {
          filters.add({
            field: joinFilter.field,
            value: value,
          });
        }
      });
    },
  });

  var QueryExecution = Mn.Object.extend({
    initialize: function() {
      Mn.Object.prototype.initialize.apply(this, arguments);

      this.query = _.extend({}, this.options);

      this.resources = [];
      this.queryResource = new QueryResource(_.extend({}, this.query, { query: true }), this);
      this.resources.push(this.queryResource);

      _.each(
        this.query.join,
        function(join) {
          this.resources.push(new JoinResource(_.extend({}, join), this));
        },
        this
      );

      _.each(this.getResources(), function(resource) {
        resource.initializeSort();
        resource.initializeFilters();
      });
    },

    getQueryResource: function() {
      return this.queryResource;
    },

    getResource: function(name) {
      return _.find(this.resources, function(resource) {
        return resource.name === name;
      });
    },

    getResources: function() {
      return this.resources;
    },

    getResourceNames: function() {
      var names = [];
      _.each(this.getResources(), function(resource) {
        if (resource.name) {
          names.push(resource.name);
        }
      });
      return names;
    },

    getResourcesByType: function(typeClass) {
      return _.filter(this.getResources(), function(resource) {
        return resource instanceof typeClass;
      });
    },

    getSortResource: function() {
      return (
        _.find(this.getResources(), function(resource) {
          return resource.isSortResource();
        }) || this.getQueryResource()
      );
    },

    findResourceForModel: function(model) {
      var foundResource = _.find(this.getResources(), function(resource) {
        return resource.collection.get(model);
      });
      return foundResource;
    },

    selectAttributesFromModelList: function(models) {
      var select = this.query.select || [];
      var attrs = {};
      _.each(
        select,
        function(selection) {
          var toCopyAttrs = {};
          var selectDefinition = this.parseSelectDefinition(selection);
          if (!selectDefinition) {
            return;
          }

          var resource = this.getResource(selectDefinition.resourceName);
          if (!resource) {
            return;
          }
          var model = resource.findOwnedModelFromList(models);
          if (!model) {
            return;
          }

          if (selectDefinition.field == '*') {
            if (selectDefinition.as) {
              toCopyAttrs[selectDefinition.as] = model.attributes;
            } else {
              toCopyAttrs = model.attributes;
            }
          } else if (selectDefinition.as) {
            toCopyAttrs[selectDefinition.as] = model.get(selectDefinition.field);
          } else if (selectDefinition.field) {
            toCopyAttrs[selectDefinition.field] = model.get(selectDefinition.field);
          }
          _.extend(attrs, toCopyAttrs);
        },
        this
      );
      return attrs;
    },

    parseSelectDefinition: function(selection) {
      var selectDefinition;
      if (_.isString(selection)) {
        selectDefinition = this.parseResourcePath(selection);
      } else if (_.isObject(selection) && selection.from) {
        selectDefinition = this.parseResourcePath(selection.from);
        if (!selectDefinition) {
          return;
        }
        selectDefinition.as = selection.as || (selectDefinition.field != '*' ? selectDefinition.field : null);
      } else {
        return;
      }
      return selectDefinition;
    },

    parseResourcePath: function(resourcePath) {
      if (!resourcePath) {
        return null;
      }

      var resourceNames = this.getResourceNames();
      var resourceName = _.find(resourceNames, function(resourceName) {
        if (AppKit.util.KeyPrefixer.hasPrefix(resourcePath, resourceName + '.')) {
          return true;
        }
      });

      if (!resourceName) {
        return {
          resourceName: null,
          field: resourcePath,
        };
      }

      return {
        resourceName: resourceName,
        field: AppKit.util.KeyPrefixer.removePrefix(resourcePath, resourceName + '.'),
      };
    },

    findResourceNameFromField: function(field) {
      var parsedField = this.parseResourcePath(field);

      if (parsedField && parsedField.resourceName) {
        return parsedField.resourceName;
      }

      var selectDefinition = _.chain(this.query.select)
        .map(this.parseSelectDefinition, this)
        .compact()
        .sort(function(selectDefinition) {
          // we want the * at the end of the list
          return selectDefinition.field == '*' ? 1 : 0;
        })
        .find(function(selectDefinition) {
          return selectDefinition.field == field || selectDefinition.field == '*';
        })
        .value();

      return selectDefinition ? selectDefinition.resourceName : null;
    },

    assembleQueryResults: function() {
      //prettier-ignore
      var outputArray             = [],
          sortResource            = this.getSortResource(),
          queryResource           = this.getQueryResource(),
          queryResourceCollection = queryResource.collection,
          resources               = this.getResources(),
          sortResourceIndex       = 0;

      while (queryResourceCollection.length > 0 && sortResourceIndex < sortResource.collection.length) {
        //prettier-ignore
        var model              = sortResource.collection.at(sortResourceIndex),
            linkedModels       = sortResource.findAllLinkedByModel(model),
            queryResourceModel = queryResource.findOwnedModelFromList(linkedModels);
        if (this.shouldAddLinkedModels(linkedModels)) {
          outputArray.push(this.selectAttributesFromModelList(linkedModels));
          queryResourceCollection.remove(queryResourceModel);
        } else {
          sortResourceIndex++;
        }
      }

      return outputArray;
    },

    shouldAddLinkedModels: function(linkedModels) {
      //prettier-ignore
      var queryResource      = this.getQueryResource(),
          queryResourceModel = queryResource.findOwnedModelFromList(linkedModels);

      return _.all(
        this.getResourcesByType(JoinResource),
        function(resource) {
          var ownedByResourceModel = resource.findOwnedModelFromList(linkedModels);
          switch (resource.getOption('joinType')) {
            case 'leftOuterJoin':
              return queryResourceModel != null;
            case 'rightOuterJoin':
              return ownedByResourceModel != null;
            case 'innerJoin':
            default:
              return ownedByResourceModel != null && resource.getJoinedModel(queryResourceModel) != null;
          }
        },
        this
      );
    },
  });

  var ResourceQueryCollection = BaseCollection.extend({
    constructor: function() {
      BaseCollection.apply(this, arguments);
      if (this.query && this.query.sort) {
        this.sort.set(SortModel.SORT_FIELD, this.query.sort.field);
        this.sort.set(SortModel.SORT_DIRECTION, this.query.sort.direction || SortModel.ASCENDING);
      }
      if (this.query && _.isArray(this.query.filters)) {
        var filterArray = _.map(this.query.filters, function(filter) {
          return resolveObjectWithStateValues(filter);
        });
        this.filters.add(filterArray);
      }
    },

    fetch: function(options) {
      options || (options = {});
      var execution = new QueryExecution(_.extend({}, this.query, { sort: this.sort, filters: this.filters }));

      var queryResource = execution.getQueryResource();
      queryResource.collection.urlParams(this._urlParams.toJSON());
      queryResource.collection.paginate.set(this.paginate.toJSON());
      var queryResourceXhr = queryResource.collection.fetch(options);

      this.trigger('request', this, queryResourceXhr, options);

      var promise = ModelUtil.resolvePromise(queryResourceXhr)
        .thenReturn(execution.getResourcesByType(JoinResource))
        .bind(this)
        .tap(function() {
          this.paginate.set(queryResource.collection.paginate.attributes, { ignoreAutoFetch: true });
        })
        .each(function(joinResource) {
          joinResource.buildFilterFromJoin();
          // we want all matching results for joined resources
          joinResource.collection.paginate.size(1000);
          if (joinResource.collection.filters.length > 0) {
            // only fetch if there are more than 0 filters
            return joinResource.collection.fetch(options).promise();
          }
        })
        .tap(function() {
          this.set(execution.assembleQueryResults(), options);
          if (options.success) options.success.call(options.context, this, {}, options);
          this.trigger('sync', this, {}, options);
          execution.destroy();
        })
        .catch(function(errorThrown) {
          if (options.error) options.error.call(options.context, queryResourceXhr, textStatus, errorThrown);
          if (!options.errorThrown) {
            options.errorThrown = errorThrown;
          }
          this.trigger('error', this, errorThrown, options);
          throw errorThrown;
        });

      queryResourceXhr.promise = function() {
        return promise;
      };

      return queryResourceXhr;
    },
  });

  ResourceQueryCollection.Resource = Resource;
  ResourceQueryCollection.QueryResource = QueryResource;
  ResourceQueryCollection.JoinResource = JoinResource;
  ResourceQueryCollection.QueryExecution = QueryExecution;

  module.exports = ResourceQueryCollection;
});

